import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { CurrencyProvider } from "@/context/CurrencyContext";
import { PromoPopup } from "@/components/layout/PromoPopup";
import { Seo } from "@/components/layout/Seo";
import Home from "@/pages/Home";
import Hotels from "@/pages/Hotels";
import Deals from "@/pages/Deals";
import Cars from "@/pages/Cars";
import Cruises from "@/pages/Cruises";
import Packages from "@/pages/Packages";
import Blog from "@/pages/Blog";
import About from "@/pages/About";
import Help from "@/pages/Help";
import Contact from "@/pages/Contact";
import AdminLogin from "@/pages/AdminLogin";
import Admin from "@/pages/Admin";
import { AirlinePage, DestinationPage, ServicePage, SiteMap, LegalPage } from "@/pages/MiscPages";

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <CurrencyProvider>
          <Seo />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/flights" element={<Home />} />
            <Route path="/hotels" element={<Hotels />} />
            <Route path="/deals" element={<Deals />} />
            <Route path="/cars" element={<Cars />} />
            <Route path="/cruises" element={<Cruises />} />
            <Route path="/holiday-packages" element={<Packages />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/about" element={<About />} />
            <Route path="/help" element={<Help />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/airlines/:slug" element={<AirlinePage />} />
            <Route path="/flights-to/:slug" element={<DestinationPage />} />
            <Route path="/group-travel" element={<ServicePage />} />
            <Route path="/business-travel" element={<ServicePage />} />
            <Route path="/student-travel" element={<ServicePage />} />
            <Route path="/site-map" element={<SiteMap />} />
            <Route path="/privacy" element={<LegalPage />} />
            <Route path="/terms" element={<LegalPage />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="*" element={<Home />} />
          </Routes>
          <PromoPopup />
          <Toaster position="top-center" richColors />
        </CurrencyProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
